import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import {
  ActiveUserOnMachine,
  WorkOrderOperation,
} from "../../odata/appu4dm/AppU4DMModel";
import {
  qActiveUserOnMachine,
  QActiveUserOnMachine,
} from "../../odata/appu4dm/QAppU4DM";
import { useMachine } from "../machine/use-machine";
import { workOrderKeys } from "./work-order-keys";

export function useWorkOrderOperationId() {
  const { machine } = useMachine();

  const { data, ...query } = useQuery({
    queryKey: workOrderKeys.getOperationId(machine?.EquipmentNId),
    queryFn: ({ meta }) =>
      fetchWorkOrderOperationId(machine!.EquipmentNId!, meta!.token!),
    enabled: ({ meta }) => !!(machine?.EquipmentNId && meta?.token),
  });

  return {
    workOrderOperationId: data?.value[0],
    ...query,
  };
}

export type WorkOrderOperationStatus = Pick<WorkOrderOperation, "Status">;
export type WorkOrderOperationId = Pick<
  ActiveUserOnMachine,
  "Id" | "WorkOrderOperation_Id"
> & { WorkOrderOperation: WorkOrderOperationStatus };

async function fetchWorkOrderOperationId(machineId: string, token: string) {
  const builder = createQueryBuilderV4(
    "ActiveUserOnMachine",
    new QActiveUserOnMachine(),
  )
    .select("Id", "WorkOrderOperation_Id")
    .expanding("WorkOrderOperation", (b) => b.select("Status", "Status"))
    .filter(
      qActiveUserOnMachine.WorkOrderOperation_Id.ne(null).and(
        qActiveUserOnMachine.Equipment.eq(machineId),
      ),
    );

  return odataFetch<WorkOrderOperationId>({ builder, token });
}
